var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"foobar":""}},_vm._l((10),function(i){return _c('div',[_c('h3',[_vm._v("Some Custom Content")]),_vm._v(" "),_c('img',{attrs:{"src":"https://vuejs.org/images/logo.png","alt":"","width":"100%"}})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0389ce03","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Demo/CustomComponent/ComponentBase.vue
// module id = null
// module chunks = 